import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Space, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import Batting from './scorecard-batting';
import Bowling from './scorecard-bowling';
import FallOfWickets from './scorecard-fow';

const ScorecardInning = ({ team, batting, bowlers, fow, gameType }) => (
  <Space bottom="large">
    <Space bottom="medium">
      <Typography align="center" component="div">
        <Badge size={48} primary={team.colours.primary} secondary={team.colours.secondary} />
      </Typography>
    </Space>
    <Space bottom="large">
      <Typography preset="subtitle--large" color="black" component="h3" align="center">
        <Trans i18nKey="teams:inning_header_text" values={{ teamName: team.name }}>
          {`${team.name} Innings`}
        </Trans>
      </Typography>
    </Space>
    {batting.batsmen.length > 0 && <Batting {...batting} gameType={gameType} team={team} />}
    {fow && fow.length > 0 && <FallOfWickets fow={fow} />}
    {bowlers.length > 0 && <Bowling bowlers={bowlers} team={team} />}
  </Space>
);

ScorecardInning.propTypes = {
  batting: PropTypes.shape().isRequired,
  bowlers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fow: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  gameType: PropTypes.oneOf(['standard', 'pairs']).isRequired,
  team: PropTypes.shape({
    id: PropTypes.number,
    oppositionTeamId: PropTypes.number,
    colours: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
};

export default ScorecardInning;
